import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e74a2aee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-min h-min py-3 pl-3 pr-4 flex border shadow-md border-primary-50 dark:border-dark-400",
  style: {"border-radius":"0.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isLightMode() ? 'load-anime' : 'load-anime-dark ')
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["text-xl my-auto ml-3", _ctx.isLightMode() ? 'text-animation' : 'text-animation-dark'])
    }, "Loading...", 2)
  ]))
}